package horcrux.frontend.common.views.collections.navigator

import horcrux.common.api.dtos.ChatPageID
import horcrux.common.api.dtos.ChatPageMetadata
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.views.collections.ChatPageMetadataByID
import mui.system.PropsWithSx
import react.FC

external interface ChatPageCollectionSelectorProps : PropsWithSx {
    var globalAppState: GlobalAppState
}

val ChatPageCollectionSelector: FC<ChatPageCollectionSelectorProps> =
    collectionSelector<ChatPageID, ChatPageMetadata, ChatPageMetadataByID>()
        .let { fc ->
            FC { props ->
                val currentChatPageMetadataMaybeState = props.globalAppState.currentChatPageMetadataMaybeState
                val chatPageMetadataByID = props.globalAppState.chatPageMetadataByIDState.get()
                fc {
                    this.globalAppState = props.globalAppState
                    this.metadataByID = props.globalAppState.chatPageMetadataByIDState.get()
                    this.componentLabelBase = "chat page"
                    this.currentMetadataMaybe = currentChatPageMetadataMaybeState.get()
                    this.labelSupplier = { it.collectionMetadata.collectionName.betterToString() }
                    this.onChange = { newID ->
                        ChatPageID(newID)
                            .onRight { chatPageID -> currentChatPageMetadataMaybeState.set(chatPageMetadataByID[chatPageID]) }
                            .onLeft { error("There was an error parsing chatPageID $newID") }
                    }
                }
            }
        }
